import { useP2GDebounce } from '@parcel2go/core-ui';
import { useEffect, useState } from 'react';

function useVisible() {
  const [realtimeVisible, setRealtimeVisible] = useState(true);
  const [visible, setVisible] = useP2GDebounce(true, realtimeVisible ? 1000 : 30000);
  useEffect(() => {
    const f = () => {
      setVisible(document.visibilityState !== 'hidden');
      setRealtimeVisible(document.visibilityState !== 'hidden');
    };
    window.addEventListener('visibilitychange', f);
    return () => window.removeEventListener('visibilitychange', f);
  }, [setVisible]);

  useEffect(() => {
    console.log(visible ? 'Powering Up Api Calls' : 'Powering Down Api Calls');
  }, [visible]);

  return [visible] as const;
}
export { useVisible };
